import React from "react";
/* eslint-disable */
import {
  Box, Grid, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const fccActivitySummaryData = this.props.fccActivitySummaryList;
    const data = this.props.searchData;
    const total = this.props.totalValues;

    return (
      <div style={{ padding: '10px' }}>
        <h3><center><u>FCC Activity Summary Report</u></center></h3>
        <div>&nbsp;</div>
        {/* <Grid style={{ padding: '20px' }} container spacing={1}>
          <Grid md={2} xs={2}>
            <h4>Group :</h4>
          </Grid>
          <br />
          <Grid md={10} xs={10}>
            {data.groupName}
          </Grid>
          <br />
          <Grid md={2} xs={2}>
            <h4>Fresh Collection Center :  </h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.factoryName}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>From :  </h4>
          </Grid>
          <Grid md={10} xs={10}>
            {new Date(data.startDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>To :</h4>
          </Grid>
          <Grid md={10} xs={10}>
            {new Date(data.endDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', minimumIntegerDigits: 2 })}
          </Grid>
        </Grid> */}

        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} align={'left'}>FCC</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align={'left'}>Date</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align={"left"}>Product Code</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align={'left'}>Product</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align={'right'}>Requested Qty</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align={'right'}>Accepted Qty</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align={'right'}>Supplied Qty</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fccActivitySummaryData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.factoryName}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {moment(data.orderDate).format("YYYY-MM-DD")}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productName}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(data.quantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(data.acceptedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(data.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} colSpan={4}>Total</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(total.RequestedQtyTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(total.AcceptedQtyTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(total.SuppliedQtyTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
